module.exports = __webpack_public_path__ + "imgs/arrow-right.88cfd8877ff350c101f685eea8e5a878.svg";